import { PL_LNG } from "../constants";

const useLngUrlEnd = (i18n) => {
    return i18n.language !== PL_LNG ? `-${i18n.language}` : ''
}

export default useLngUrlEnd